import { z } from "zod"

export const addMemberToGroupSchema = z.object({
  groupUuid: z.string().uuid(),
  groupRoleUuid: z.string().uuid().optional(),
  title: z.string().max(255).optional(),
})

export type AddMemberToGroupData = z.output<typeof addMemberToGroupSchema>
